export enum ProductType {
  Image = 'image',
  Video15s = 'video15s',
  Video30s = 'video30s',
  CustomImage = 'customImage',
  CustomVideo = 'customVideo',
}
